import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M15.25 17H4.75C4.3125 17 4 16.6875 4 16.25C4 15.8438 4.3125 15.5 4.75 15.5L15.25 15.5C15.6563 15.5 16 15.8437 16 16.25C16 16.6875 15.6563 17 15.25 17ZM9.4375 12.7812L5.4375 8.53125C5.15625 8.21875 5.1875 7.75 5.46875 7.46875C5.78125 7.1875 6.25 7.1875 6.53125 7.5L9.25 10.375V7.75L9.25 3.75C9.25 3.34375 9.5625 3 10 3C10.4062 3 10.75 3.34375 10.75 3.75L10.75 7.75V10.375L13.4375 7.5C13.7188 7.1875 14.1875 7.1875 14.5 7.46875C14.8125 7.75 14.8125 8.21875 14.5313 8.53125L10.5313 12.7812C10.375 12.9375 10.1875 13 10 13C9.78125 13 9.59375 12.9375 9.4375 12.7812Z"
	})
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
